(function() {
    'use strict';
    angular
        .module('emarket.commons')
        .factory('File', ['$http', 'Upload', 'PATH', function($http, Upload, PATH) {
            var path = PATH.api + '/file';
            var file = {
                create: function(image) {
                    return Upload.upload({
                        url: path,
                        data: {
                            image: image
                        }
                    }).then(function(response) {
                        return response.data;
                    });
                },
                delete: function(image) {
                    var url = path + '/' + image;
                    return $http.delete(url).then(function(response) {
                        return response.data;
                    });
                }
            };
            return file;
        }]);
}());
